import { Component, Inject, output, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { FormioForm } from '@formio/angular';
import { cloneDeep, isNil } from 'lodash';
import { ScwFormioBuilderComponent } from '../../../../shared/components/scw-formio-builder/scw-formio-builder.component';

@Component({
  imports: [ReactiveFormsModule, ScwFormioBuilderComponent],
  selector: 'app-form-editor',
  standalone: true,
  templateUrl: './form-editor.component.html',
})
export class FormEditorComponent {
  public editedForm = signal<FormioForm | undefined>(undefined);
  public editedFormChanged = output<FormioForm>();

  public readonly defaultForm: FormioForm = { components: [], display: 'form' };
  public initialForm: FormioForm = cloneDeep(this.defaultForm);
  public static readonly dialogConfig: MatDialogConfig = {
    disableClose: true,
    maxWidth: '95vw',
    restoreFocus: false,
    width: '95vw',
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data: FormioForm) {
    if (!isNil(data)) {
      this.initialForm = this.data;
    }
  }

  public setEditedForm($event: FormioForm): void {
    this.editedForm.set($event);
    this.editedFormChanged.emit($event);
  }
}
